module.exports = __webpack_public_path__ + "static/img/guide-04.ac637613.png";